import React, { useState } from 'react';

const REASONS = [
  'Preis zu hoch',
  'Konkurrenz gewählt',
  'Kein Budget',
  'Kein Bedarf',
  'Falscher Zeitpunkt',
  'Keine Rückmeldung',
  'Produkt passt nicht',
  'Internes Projekt',
  'Sonstiges',
];

export default function LossReasonModal({ lead, onConfirm, onCancel }) {
  const [reason, setReason] = useState('');
  const [note,   setNote]   = useState('');

  function handleConfirm() {
    if (!reason) return;
    onConfirm({ lossReason: reason, lossNote: note.trim() || null, lossDate: new Date().toISOString().slice(0, 10) });
  }

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 900, background: 'rgba(15,23,42,0.5)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'var(--bg2)', borderRadius: 16, width: 440, boxShadow: '0 24px 64px rgba(15,23,42,0.28)', border: '1px solid var(--border)', fontFamily: 'var(--font)', overflow: 'hidden' }}>

        {/* Header */}
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: 'rgba(220,38,38,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
          </div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text)' }}>Deal-Verlust dokumentieren</div>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 1 }}>{lead?.name}{lead?.company ? ` · ${lead.company}` : ''}</div>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: '18px 22px' }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 10 }}>Verlustgrund *</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: 16 }}>
            {REASONS.map(r => (
              <button key={r} onClick={() => setReason(r)}
                style={{ padding: '8px 12px', borderRadius: 8, fontSize: 12, fontWeight: 500, textAlign: 'left', cursor: 'pointer', transition: 'all .1s', border: `1.5px solid ${reason === r ? '#dc2626' : 'var(--border)'}`, background: reason === r ? 'rgba(220,38,38,0.07)' : 'var(--bg3)', color: reason === r ? '#dc2626' : 'var(--text2)' }}>
                {r}
              </button>
            ))}
          </div>
          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>Notiz (optional)</div>
          <textarea
            value={note} onChange={e => setNote(e.target.value)}
            placeholder="Details zum Verlust…"
            rows={3}
            style={{ width: '100%', borderRadius: 8, border: '1.5px solid var(--border)', background: 'var(--bg3)', color: 'var(--text)', fontSize: 13, padding: '10px 12px', outline: 'none', resize: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
          />
        </div>

        {/* Footer */}
        <div style={{ padding: '12px 22px', borderTop: '1px solid var(--border)', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onCancel} style={{ height: 36, padding: '0 16px', borderRadius: 8, background: 'var(--bg3)', border: '1px solid var(--border)', color: 'var(--text2)', fontSize: 13, cursor: 'pointer' }}>
            Überspringen
          </button>
          <button onClick={handleConfirm} disabled={!reason}
            style={{ height: 36, padding: '0 20px', borderRadius: 8, background: reason ? '#dc2626' : 'var(--bg4)', border: 'none', color: reason ? '#fff' : 'var(--text3)', fontSize: 13, fontWeight: 600, cursor: reason ? 'pointer' : 'default', transition: 'all .12s' }}>
            Speichern
          </button>
        </div>
      </div>
    </div>
  );
}
